export default __webpack_public_path__ + "static/c87e10b26adf0f0d9b9d0aa112e3972d.jpg";